/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessListDto } from '../../models/kyc-process-list-dto';

export interface GetAll2$Params {
  managementCompanyId: string;
}

export function getAll2(http: HttpClient, rootUrl: string, params: GetAll2$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessListDto>> {
  const rb = new RequestBuilder(rootUrl, getAll2.PATH, 'get');
  if (params) {
    rb.query('managementCompanyId', params.managementCompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessListDto>;
    })
  );
}

getAll2.PATH = '/kyc/processes';
